import { createStore } from "vuex";

import { auth } from "@/store/modules/auth";
import { loader } from "@/store/modules/loader";
import { user } from "@/store/modules/user";
import { company } from "@/store/modules/company";
import { job } from "@/store/modules/job";
import { role } from "@/store/modules/role";
import { documentConstructor } from "@/store/modules/documentConstructor";
import { nomenclature } from "@/store/modules/nomenclature";
import { processTemplate } from "@/store/modules/processTemplate";
import { document } from "@/store/modules/document";
import { processUser } from "@/store/modules/processUser";
import { documentTemplate } from "@/store/modules/documentTemplate";
import { logs } from "@/store/modules/logs";
import { documentHistory } from "@/store/modules/documentHistory";
import { route } from "@/store/modules/route";
import { transferAuthority } from "@/store/modules/transferAuthority";
import { entityApproval } from "@/store/modules/entityApproval";
import { notification } from "@/store/modules/notification";
import { report } from "@/store/modules/report";
import { reportTemplate } from "@/store/modules/reportTemplate";
import { reportFile } from "@/store/modules/reportFile";

// Authentication has its own storage. Never restore another account's business data.
localStorage.removeItem("vuex");

export const store = createStore<IRootState>({
  state: {
    version: 1,
  },
  modules: {
    auth,
    loader,
    user,
    company,
    job,
    role,
    documentConstructor,
    nomenclature,
    processTemplate,
    document,
    processUser,
    documentTemplate,
    logs,
    documentHistory,
    route,
    notification,
    transferAuthority,
    entityApproval,
    report,
    reportTemplate,
    reportFile,
  },
});

/*type MutationPayload = moduleAuth.MutationPayload;

type ActionsPayload = moduleAuth.ActionsPayload;

type Getters = moduleAuth.Getters;*/

/*export type Store = Omit<
    VuexStore<State>,
    "getters" | "commit" | "dispatch"
    > & {
  commit<K extends keyof MutationPayload>(
      key: K,
      payload: MutationPayload[K],
      options?: CommitOptions
  ): void;
} & {
  dispatch<K extends keyof ActionsPayload>(
      key: K,
      payload: ActionsPayload[K][0],
      options?: DispatchOptions
  ): ActionsPayload[K][1];
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>;
  };
};

export function useStore(): Store {
  return store as Store;
}*/

export interface IPager {
  buttonsToShow: number;
  currentPage: number;
  endPage: number;
  startPage: number;
  totalPages: number;
  totalItems?: number;
  pageSize?: number;
}

export interface IDataProvider<T> {
  items: Array<T>;
  pager: IPager;
}

export interface IBackendResponse<T> {
  data: IDataProvider<T>;
  message: string;
  status: boolean;
  type: string;
}

export interface IRootState {
  version: number;
}

export enum StatusesEnum {
  ACTIVE = "ACTIVE",
  DISABLE = "DISABLE",
  DISABLED = "DISABLED",
}

export const statuses = {
  [StatusesEnum.ACTIVE]: "Активно",
  [StatusesEnum.DISABLE]: "Отключено",
  [StatusesEnum.DISABLED]: "Отключено",
};
